// External ScoreApp "Signal State Snapshot" assessment (7-9 questions).
// Signal State ID links OUT to this — it does NOT recreate the Snapshot.
// Swap this value (or set REACT_APP_SCOREAPP_URL) when the live ScoreApp URL is ready.
export const SCOREAPP_SNAPSHOT_URL =
  process.env.REACT_APP_SCOREAPP_URL || "https://scoreapp.com/REPLACE-WITH-YOUR-SNAPSHOT-URL";

export const scoreAppConfigured = () =>
  !SCOREAPP_SNAPSHOT_URL.includes("REPLACE-WITH-YOUR-SNAPSHOT-URL");
